
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";


const VersionHistoryPage = () => {

    const { i18n } = useTranslation();
    const nav = useNavigate();

    const currentLanguage = i18n.language;



    return (
        <div className="container mt-4">
            {currentLanguage === 'fi' && (
                <>

                    <a href="#" className="mt-2 mb-2" onClick={() => { nav(`/home`) }}>Takaisin pääsivulle</a>    

                    <h1>
                        Versiohistoria:
                    </h1>

                    <ol>
                        <ul>
                            <strong>26.9.2025</strong>
                            <ul>
                                <li>StationView
                                    <ul>
                                        <li>Tiedotteiden lähetys</li>
                                    </ul>
                                </li>
                            </ul>

                            <strong>4.9.2025</strong>
                            <ul>
                                <li>Management
                                    <ul>
                                        <li>Yksikön vahvuuksissa otsikot</li>
                                        <li>Käyttäjätunnus - sähköposti</li>
                                        <li>Asemasarake käyttäjä- jä yksikkölistoille</li>                                      
                                    </ul>
                                </li>

                                <li>StationView
                                    <ul>
                                        <li>Karttapäivitys</li>
                                        <li>Päivämäärä yli 24 tuntia vanhoissa tehtävissä.</li>
                                        <li>Automaattiskrollaus oletuksena pois päältä.</li>
                                        <li>Tehtäväaika ensimmäisestä tehtävään liittyvästä viestistä.</li>
                                        <li>Näytetään tehtävän päivitysaika</li>
                                        <li>Näytetään tehtävän ja kohteen lisätiedot.</li>   
                                        <li>Näytettävä aikaväli talletetaan</li>
                                    </ul>
                                </li>
                                <li>Leaderview
                                    <ul>
                                        <li>Päivämäärä yli 24 tuntia vanhoissa tehtävissä.</li>
                                        <li>Tehtävien järjestys korjattu</li>
                                        <li>Ylityökutsu - kysely</li>
                                        <li>Näytettävä aikaväli talletetaan</li>
                                    </ul>
                                </li>
                            </ul>

                            <strong>21.8.2025</strong>                            
                            <ul>
                                <li>Management
                                    <ul>
                                        <li>Yksiköt-, käyttäjät- ja tehtäväkyvykkyyssivuille lisätty suodatus aseman perusteella.</li>
                                        <li>Käyttäjien kyvykkyydet listattu aakkosjärjestyksessä.</li>    
                                        <li>Tavoitekyvykkyydet listattu aakkosjärjestyksessä sekä tehtäväkyvykkyyksien koodirivit järjestetty koodien mukaan.</li>
                                        <li>Tehtäväkyvykkyyksien lisääminen ilman yksikön valintaa estetty.</li>                                        
                                    </ul>                                        
                                </li>

                                <li>StationView
                                    <ul>
                                        <li>Korjaus kartan koordinaatteihin.</li>
                                        <li>Käyttäjien kyvykkyydet listattu aakkosjärjestyksessä.</li>
                                        <li>Ilmoittautuneet sarakkeen otsikon vieressä näytetään ilmoittautuneiden määrä.</li>
                                        <li>Ilmoittautumisten lisäyksessä näytetään henkilölistalla "Toiselle asemalle", mikäli henkilö on ilmoittautunut valitun aseman sijaan jollekin toiselle asemalle.</li>
                                        <li>24h, 48h ja 72h aikavalinta</li>
                                    </ul>
                                </li>
                                <li>Leaderview
                                    <ul>
                                        <li>48h ja 72h aikavalinta.</li>
                                    </ul>
                                </li>
                            </ul>
                        </ul>                     
                    </ol>
                </>)}

            {currentLanguage === 'en' && (
                <>
                    <a href="#" className="mt-2 mb-2" onClick={() => { nav(`/home`) }}>Back to main page</a>  

                    <h1>
                        Version history:
                    </h1>

                    <ol>
                        <ul>
                            <strong>26.9.2025</strong>
                            <ul>
                                <li>StationView
                                    <ul>
                                        <li>Send bulletins from station view</li>
                                    </ul>
                                </li>
                            </ul>

                            <strong>4.9.2025</strong>
                            <ul>
                                <li>Management
                                    <ul>
                                        <li>Unit strenght has labels</li>
                                        <li>"Username" changed to "email"</li>
                                        <li>Station column in unit and user lists.</li>
                                    </ul>
                                </li>

                                <li>StationView
                                    <ul>
                                        <li>Map update</li>
                                        <li>Show date in missions over 24 hours old</li>
                                        <li>Automatic scrolling is disabled on start</li>
                                        <li>Take mission time from first mission message</li>
                                        <li>Show mission update time</li>
                                        <li>Show alarm and target extra information</li>
                                        <li>Time filtering value is saved</li>
                                    </ul>
                                </li>
                                <li>Leaderview
                                    <ul>
                                        <li>Show date in missions over 24 hours old</li>
                                        <li>Mission sorting fix</li>
                                        <li>Changed "Ylityökutsu" to "Kysely"</li>
                                        <li>Time filtering value is saved</li>
                                    </ul>
                                </li>
                            </ul>

                            <strong>21.8.2025</strong>
                            <ul>
                                <li>Management
                                    <ul>
                                        <li>Added filtering by station to Units, Users, and Unit Mission Capabilities pages.</li>
                                        <li>On the Users page, capabilities are listed in alphabetical order.</li>
                                        <li>In Unit Mission Capabilities, target capabilities are listed in alphabetical order, and code rows are sorted by codes.</li>
                                        <li>Prevented adding mission capabilities without selecting a unit.</li>
                                    </ul>
                                </li>

                                <li>StationView
                                    <ul>
                                        <li>Fixed map coordinates.</li>
                                        <li>User capabilities are listed in alphabetical order.</li>
                                        <li>The number of signed up users is displayed next to the column header "Ilmoittautuneet".</li>
                                        <li>When adding signed up users, the person list shows "Toiselle asemalle" if the person has signed up to a different station instead of the selected one.</li>
                                        <li>Added 24h, 48h, and 72h time selection.</li>
                                    </ul>
                                </li>

                                <li>LeaderView
                                    <ul>
                                        <li>Added 48h and 72h time selection.</li>
                                    </ul>
                                </li>
                            </ul>
                        </ul>
                    </ol>
                </>)}
      
        </div>
    )
}

export default VersionHistoryPage;